import { render, staticRenderFns } from "./ConcurentPage.vue?vue&type=template&id=a039320a&scoped=true&"
import script from "./ConcurentPage.vue?vue&type=script&lang=js&"
export * from "./ConcurentPage.vue?vue&type=script&lang=js&"
import style0 from "./ConcurentPage.vue?vue&type=style&index=0&id=a039320a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a039320a",
  null
  
)

/* custom blocks */
import block0 from "./ConcurentPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports